'use strict';

import AppData from 'Data/AppData';
import { getUserManagingOrgIds } from 'Data/context/Organizations';
import { OBJECT_STATUS } from 'Data/Enum';
import { canUserViewAllCores } from 'Util';
import GenericTableData from './GenericTableData';

let orgListForUser;
// Org Module Event Bus. Handles all interactions with Orgs.
let OrgData = GenericTableData.getTableDataBus('ORG', 'organizations');

OrgData.getOrgAndAssociations = (id) => {
  return OrgData.getRecord(id, {
    _include: 'addresses,charge_accounts,user_organization_roles,resources',
  });
};

OrgData.populateOrgs = () => {
  OrgData.populateUserOrgs();
  OrgData.getAllRecords({ fields: 'name,short_name,pi_id,status,tags' }).then(
    (results) => {
      let fullOrgList = results?.records || [];
      OrgData.notifyListeners('ALL_ORGS_LOADED', fullOrgList);
      return fullOrgList;
    },
  );
};

OrgData.populateUserOrgs = () => {
  if (AppData.organizationRoles()?.length) {
    let idSet = new Set(
      AppData.organizationRoles().map((role) => role.split('::')[0]),
    );
    if (
      orgListForUser?.length &&
      orgListForUser.map((org) => org.id).every((id) => idSet.has(`${id}`))
    ) {
      return orgListForUser;
    } else {
      OrgData.getRecords([...idSet])
        .then((records) => {
          orgListForUser = records.filter(
            (obj) => obj.status === OBJECT_STATUS.ACTIVE.key,
          );
          OrgData.notifyListeners('USER_ORGS_LOADED', orgListForUser);
          return records;
        })
        .catch((err) => {
          console.log(`Unable to get org list for user. Error: ${err}`);
        });
    }
  }
};

OrgData.getOrgList = (opts) => {
  let where = {
    ...(opts?.where && { ...opts.where }),
  };
  if (!canUserViewAllCores() && !Object.hasOwn(where, '*id')) {
    where['*id'] = getUserManagingOrgIds();
  }
  let options = {
    ...opts,
    where: where,
  };
  return OrgData.getRecordList(options);
};

OrgData.createOrg = (recordData) => {
  return OrgData.createRecord(recordData).then((results) => {
    OrgData.populateOrgs();
    return results;
  });
};

export default OrgData;
